module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    staticClass: "ql-marker-nav-item",
    class: _vm.navItemClasses,
    nativeOn: {
      "click": function($event) {
        return _vm.gotoPage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "ql-marker-nav-row"
  }, [_c('bookmark-type-icon', {
    staticClass: "ql-marker-nav-icon",
    attrs: {
      "type": _vm.marker.type
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ql-marker-nav-text"
  }, [_c('span', {
    staticClass: "ql-marker-nav-page"
  }, [_vm._v("p " + _vm._s(_vm.pageName))]), _vm._v(" "), _c('span', {
    staticClass: "ql-marker-nav-label"
  }, [_vm._v(_vm._s(_vm.displayLabel))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-436c482c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/bookmark/marker-nav-item.vue
// module id = 1234
// module chunks = 21